import { Component, OnInit } from '@angular/core';
import { RequestTrainingService } from './request-training.service';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-request-training',
  templateUrl: './request-training.component.html',
  styleUrls: ['./request-training.component.scss']
})
export class RequestTrainingComponent implements OnInit {
  cols: any[];
  trainingData: any;
  loading: boolean = true;
  requestClosed: boolean = false;
  email: any;

  constructor(private RequestTrainingService: RequestTrainingService, private toastr: ToastrService,) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getRequestTrainingData();
  }

  getRequestTrainingData() {
    this.RequestTrainingService.getRequestData(this.email).subscribe((response) => {
      this.trainingData = response["data"];
      console.log("resss", this.trainingData);
      this.loading = false;
    });
  }

  closeRequest(email, org, username, ip, request) {
    const data = {
      client_email: email,
      client_organization: org,
      client_username: username,
      ip: ip,
      request_made: request
    };
    console.log(data)
    this.RequestTrainingService.postRequestData(data).subscribe((response) => {
      this.toastr.success('Request Closed Successfully', 'Success');
      window.location.reload();
      // this.requestClosed = true;
    },
      (error) => {
        console.error('Error:', error);
        this.toastr.error('Failed to close request', 'Error');
      }
    );
    // this.getRequestTrainingData()
  }

}
